import * as React from "react";
import type { CategoryNode } from "@iterate/common/types/shared";

interface CategoryContext {
  deleteCategory(category: CategoryNode): void;
  editCategory(category: CategoryNode): void;
  updateCategory(category: CategoryNode): void;
  createChildCategory(category: CategoryNode): void;
}

export const CategoryContext = React.createContext<CategoryContext>({} as any);
